import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isFormData = req.body instanceof FormData;

    let headers = req.headers
      .set('Accept', req.headers.get('Accept') || 'application/json')
      .set('authorization', this.auth.getToken() || '');

    if (!isFormData) {
      headers = headers.set('Content-Type', req.headers.get('Content-Type') || 'application/json');
    }

    const authReq = req.clone({ headers });
    return next.handle(authReq);
  }
}
